import { getDefaultOwnerInfoQueryOptions } from '@eigtech/ui-shared-white-label'
import { applyWhiteLabelTheme } from '@eigtech/ui-shared-white-label-web'
import { Container, NotFoundError } from '@eigtech/ui-shared-dave'
import { createRootRouteWithContext } from '@tanstack/react-router'
import { AppContainer, App as BaseApp, PreAuthProviders } from '../components/Core/App'
import { log } from '../lib/log'
import { queryClient } from '../store/queryClient'

export const Route = createRootRouteWithContext<{ queryClient: typeof queryClient }>()({
  // Load the white label theme before the app shell renders, so the first paint is
  // already branded. staleTime keeps it from re-running on every route re-match -
  // the router's own SWR cache defaults to 0.
  staleTime: Infinity,
  loader: async ({ context }) => {
    try {
      const {
        theme: { ui },
      } = await context.queryClient.ensureQueryData(getDefaultOwnerInfoQueryOptions())
      applyWhiteLabelTheme(ui)
    } catch (error) {
      log.warn('failed to load the white label theme, falling back to the default colors', error)
      // a locally persisted override still applies on top of those defaults
      applyWhiteLabelTheme()
    }
  },
  component: () => (
    <PreAuthProviders>
      {/* <Outlet /> located in apps/cinnamon/ui-delegate/src/components/Core/App/App.tsx */}
      <BaseApp />
    </PreAuthProviders>
  ),
  notFoundComponent: () => (
    <AppContainer>
      <Container maxW="container.text">
        <NotFoundError />
      </Container>
    </AppContainer>
  ),
})
